import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { config } from "./config";

//APP_INSIGHTS
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: config.insights_key,
  },
});
appInsights.loadAppInsights();

export default appInsights;
